import type { AuthStoreRepository } from '@/shared/contracts/authStore.repository';
import type { AuthUserEntityStore } from '@/shared/models/authStore.model';
import { useAuthStore } from '@/shared/stores/auth.store';

/**
 * Implementación del repositorio de store de autenticación usando Zustand
 * Abstrae el store detrás de una interfaz para el LoginUseCase
 */
class AuthStoreApiRepository implements AuthStoreRepository {
  saveAuthData(authData: AuthUserEntityStore): void {
    useAuthStore.getState().login(authData);
  }
}

export const authStoreApiRepository = new AuthStoreApiRepository();
